export class SpinnerChangedEventArgs {

	constructor(public change: number) {

	}

}
